import { ASSIGNMENTS } from 'constants/actionTypes';
import moment from 'moment';

const initialState = {
  assignDirectly: [],
  checkedCount: 0,
  selectedIds: [],
  selectPathIds: [],
  markBulkComplete: true,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case ASSIGNMENTS.DIRECT_ASSIGN.RECEIVE:
      return {
        assignDirectly: action.assignments.length ? action.assignments : null,
        checkedCount: 0,
        selectedIds: [],
        selectPathIds: [],
        markBulkComplete: true,
      };

    case ASSIGNMENTS.ACTION.SELECT_ALL:
      state.assignDirectly = state.assignDirectly.map(data => {
        if (action.checked) {
          if (data.isPathLesson) {
            state.selectPathIds.push(data.id);
            state.markBulkComplete = false;
          }
          state.selectedIds.push(data.id);
        } else {
          state.selectedIds = [];
          state.selectPathIds = [];
          state.markBulkComplete = true;
        }
        return { ...data, isChecked: action.checked };
      });
      return {
        ...state,
        checkedCount: action.checked ? state.assignDirectly.length : 0,
      };

    case ASSIGNMENTS.ACTION.SELECT_SINGLE:
      if (action.checked) {
        state.selectedIds = [...state.selectedIds, action.id];
      } else {
        state.selectedIds = state.selectedIds.filter(sid => {
          return sid !== action.id;
        });
      }
      state.assignDirectly = state.assignDirectly.map(data => {
        if (data.id === action.id && data.isPathLesson) {
          if (action.checked) state.selectPathIds.push(data.id);
          else state.selectPathIds.pop();
        }
        return data.id === action.id
          ? { ...data, isChecked: action.checked }
          : data;
      });
      return {
        ...state,
        checkedCount: action.checked
          ? state.checkedCount + 1
          : state.checkedCount - 1,
        markBulkComplete: !state.selectPathIds.length,
      };

    case ASSIGNMENTS.ACTION.DELETE_ASSIGNMENT:
      state.assignDirectly = state.assignDirectly.filter(data => {
        if (data.id === action.id && data.isPathLesson && data.isChecked)
          state.selectPathIds.pop();
        if (data.id === action.id && data.isChecked) state.checkedCount -= 1;
        return action.id !== data.id;
      });
      state.selectedIds = state.selectedIds.filter(sid => {
        return action.id !== sid;
      });
      return {
        ...state,
        markBulkComplete: !state.selectPathIds.length,
      };

    case ASSIGNMENTS.ACTION.DELETE_BULK_ASSIGNMENT:
      state.assignDirectly = state.assignDirectly.filter(
        obj => !state.selectedIds.includes(obj.id),
      );
      return {
        ...state,
        checkedCount: 0,
        selectedIds: [],
        selectPathIds: [],
        markBulkComplete: true,
      };

    case ASSIGNMENTS.ACTION.UPDATE_BULK_DATE:
      state.assignDirectly = state.assignDirectly.map(values => {
        return values.isChecked
          ? {
              ...values,
              dueBy: action.date,
              isChecked: false,
              status: 'assigned',
            }
          : values;
      });
      return {
        ...state,
        checkedCount: 0,
        selectedIds: [],
        selectPathIds: [],
        markBulkComplete: true,
      };

    case ASSIGNMENTS.ACTION.UPDATE_DATE:
      state.assignDirectly = state.assignDirectly.map(values => {
        return values.id === action.id
          ? { ...values, dueBy: action.date, status: 'assigned' }
          : values;
      });
      return {
        ...state,
      };

    case ASSIGNMENTS.ACTION.MARK_COMPLETE:
      state.assignDirectly = state.assignDirectly.map(values => {
        return values.id === action.id
          ? {
              ...values,
              timeTaken: values.timeTaken ? values.timeTaken + 1 : 1,
              completedAt: moment(Date.now()),
              startedAt: values.startedAt
                ? values.startedAt
                : moment(Date.now()),
              status: 'completed',
            }
          : values;
      });
      return { ...state };
    default:
      return state;
  }
};
